var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.773 7.386l.068.066A5.248 5.248 0 008.36 9.454V8.062a.539.539 0 01.851-.438l4.19 2.993a.539.539 0 010 .877l-4.19 2.993a.539.539 0 01-.851-.439v-1.407c-2.578-.287-4.703-2.583-5.296-4.586l-.052-.192a.468.468 0 01.102-.41l.064-.062a.474.474 0 01.595-.005zM10 0a2 2 0 012 2v6.01l-1-.714V2.2A1.2 1.2 0 009.8 1H2.2a1.2 1.2 0 00-1.194 1.077L1 2.2v8.6a1.2 1.2 0 001.077 1.194L2.2 12l1.95.001c.42.379.879.716 1.365 1L2 13a2 2 0 01-2-2V2a2 2 0 012-2h8zM4.5 6a.5.5 0 110 1h-2a.5.5 0 110-1h2zm2-2a.5.5 0 110 1h-4a.5.5 0 110-1h4zm2-2a.5.5 0 110 1h-6a.5.5 0 110-1h6z",
    fill: "#596168",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;